import { UrlMatchResult, UrlSegment, UrlMatcher } from '@angular/router';

const RESERVED_SIX_CHAR_SEGMENTS = new Set(['invite', 'index', 'app']);

/**
 * Matches `/XXXXXX` short invitation ids on the support web app (no `/invite/` prefix).
 */
export const supportShortInviteLinkMatcher: UrlMatcher = (segments: UrlSegment[]): UrlMatchResult | null => {
  if (segments.length !== 1) {
    return null;
  }
  const path = segments[0].path;
  if (path.length !== 6 || !/^[A-Za-z0-9]{6}$/.test(path)) {
    return null;
  }
  if (RESERVED_SIX_CHAR_SEGMENTS.has(path.toLowerCase())) {
    return null;
  }
  return { consumed: segments };
};
